import React from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      icon: 'bi-code-slash',
      title: 'Custom Software Development',
      description: 'Build scalable web and backend systems with modern stacks—Node.js, React, Python, .NET—and architecture designed for growth.',
      badge: 'Most Popular',
      link: '/services/1'
    },
    {
      icon: 'bi-cloud-arrow-up',
      title: 'Cloud & DevOps',
      description: 'Migrate to AWS, Azure, or GCP and automate CI/CD, infrastructure-as-code, and monitoring for reliability and cost control.',
      link: '/services/2'
    },
    {
      icon: 'bi-layout-text-window-reverse',
      title: 'UI/UX Design & Development',
      description: 'User-centered design, prototypes, and front-end implementation that improve engagement and support your product goals.',
      link: '/services/3'
    },
    {
      icon: 'bi-phone',
      title: 'Mobile App Development',
      description: 'Native and cross-platform mobile apps for iOS and Android, from MVPs to enterprise solutions with secure APIs.',
      link: '/services/4'
    },
    {
      icon: 'bi-diagram-3',
      title: 'System Integration & APIs',
      description: 'Integrate legacy systems, ERPs, CRMs, and third-party services with robust APIs and event-driven architectures.',
      link: '/services/5'
    },
    {
      icon: 'bi-shield-check',
      title: 'Cybersecurity & Compliance',
      description: 'Security audits, penetration testing, and compliance support for SOC 2, GDPR, and industry-specific frameworks.',
      link: '/services/6'
    }
  ];

  return (
    <section id="services" className="services section">


      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-4">
          {services.map((service, index) => (
            <div key={index} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={200 + (index * 100)}>
              <div className="service-card">
                <div className="service-icon">
                  <i className={`bi ${service.icon}`}></i>
                </div>
                <h4><Link to={service.link}>{service.title}</Link></h4>
                <p>{service.description}</p>
                {service.badge && <div className="service-badge">{service.badge}</div>}
                <Link to={service.link} className="service-link">
                  <span>Learn More</span>
                  <i className="bi bi-arrow-right"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="row mt-5">
          <div className="col-12 text-center" data-aos="fade-up" data-aos-delay="400">
            <div className="services-cta">
              <h3>Ready to Transform Your Digital Presence?</h3>
              <p>Let's discuss your project and create something amazing together</p>
              <Link to="/contact" className="btn btn-primary">Get Started Today</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
